<template>
  <!-- 去除底部button -->
  <div class="empty">
  </div>
</template>

<script>
  export default {
    name: 'empty'
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .empty{
    /* height: 2.35rem; */
    height: 1..15rem;
    width: 100%;
  }
 
</style>